<style>
.constructor {
    display: flex;
    width: 100%;
}
.middle.constructor {
    flex-direction: column;
}
.constructor_img img:nth-child(2) {
    position: absolute;
    left: 0;
    z-index: 999;
    /*min-height: 100%;*/
}
.constructor_img img{
    width: 100%;
    height: auto;
    display: block;
}
.constructor_img {
    width: 75%;
    /* height: 100%; */
    background-size: contain;
    display: flex;
    flex-direction: row;
    position: relative;
    margin: 0 auto;
}
.middle .constructor_img {
    width: 75%;
    display:block;
}
.constructor_left {
    display: flex;
    left: 0;
    top: 0;
    width: 14.8%;
    height: 100%;
    position: absolute;
}
.constructor_side .plus {
    border: 1px solid black;
}
.frost {
    height: 99%;
    border: 1px solid black;
    background-position: center;
}
.frost_hidden{
    height:100%;
    z-index:100000;
}
.top_side_constructor_top .frost_hidden{
    height: 52px;
}
.middle .top_side_constructor_top .frost_hidden{
    height: 32px;
}
.constructor_top .plus{
    height: 97%;
}
:global(.plus) {

    height: 100%;
    background-position: center;
    /*cursor: pointer;*/
    position: absolute;
    max-width: 100%;

}
.plus:hover:after{
    background: url('./images/red-plus.png') no-repeat;
    background-position: center;
}
.plus:after{
    content: "";
    display: block;
    background: url('./images/plus.png') no-repeat;
    height: 100%;
    background-position: center;
    /*cursor: pointer;*/
    position: absolute;
    max-width: 100%;
    width: 100%;
    z-index: 99999;
}
.middle .plus:after{
    background-size: 11px;
}
.middle .plus:hover:after{
    background-size: 11px;
}
.top_side_constructor_bot .plus, .top_side_constructor_top .plus{
    background: unset;
}
.top_side_constructor_bot .plus:hover:after, .top_side_constructor_top .plus:hover:after{
    border-color: #ff0000;
    background: url('./images/red-plus.png') no-repeat;
    background-position: center;
}
.top_side_constructor_bot .plus:after, .top_side_constructor_top .plus:after{
    background: unset;
    content: "";
    background: url('./images/plus.png') no-repeat;
    height: 100%;
    background-position: center;
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    border: 1px solid #000;
    left: 50%;
    margin-left: -26px;
    z-index: 100000;
}
.top_side_constructor_bot .plus:after{
    margin-top: 10px;
}
.middle .top_side_constructor_bot .plus:after, .middle .top_side_constructor_top .plus:after{
    width: 15px;
    height: 15px;
    background-size: 11px;
    background-position: center;
}
.middle .top_side_constructor_bot .plus:after{
    margin-top: 5px;
}
.constructor_bot div:hover  {
    box-shadow: 0px 0px 0px 2px red inset;
    border: unset;
    height: 99%;
    border-right: 1px solid black;
}
.constructor_bot .plus:hover  {
    box-shadow: 0px 0px 0px 2px red inset;
    border: unset;
    height: 99%;
}
.constructor_top div:hover  {
    box-shadow: 0px 0px 0px 2px red inset;
    border: unset;
    height: 97%;
    border-right: 1px solid black;
}
:global(.constructor_top .plus:hover)  {
    box-shadow: 0px 0px 0px 2px red inset;
    border: unset;
    height: 97%;
}
.exceptionElement {
    position: absolute;
    height: 100%;
    background-color: red;
    opacity: 0.6;
    display:none;
}
.exceptionElementTopSide {
    position: absolute;
    height: 100%;
    background-color: red;
    opacity: 0.6;
    display:none;
}
.dragstart .exceptionElement {
    display:block;
}
.dragstart_topside .exceptionElementTopSide {
    display:block;
}
.dragover {
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:2;
    background-color:green;
    opacity:0.3;
    display:none;
    z-index: 9999999;
}
.dragstart .dragover {
    display:block;
}
.dragover_topside {
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:2;
    background-color:green;
    opacity:0.3;
    display:none;
    z-index: 9999999;
}
.dragstart_topside .dragover_topside {
    display:block;
}
.constructor_middle {
    display: flex;
    left: 14.8%;
    width: 70.4%;
    top: 0;
    height: 100%;
    flex-direction: column;
    position: absolute;
}
.top_side_constructor_top .frost_hidden{
    height: 52px;
}
.middle .top_side_constructor_top .frost_hidden{
    height: 32px;
}
.top_side_constructor_top {
    display: flex;
    width: 100%;
    position: absolute;
    top: -50px;
    left: 0;
    height: 70px;
    padding-top: 10px;
}
.middle .top_side_constructor_top {
    top: -24px;
    height: 32px;
    padding-top: 5px;
}
.constructor_top .frost{
    height: 97%;
}
.constructor_top .plus{
    height: 97%;
}
.constructor_top div:hover  {
    box-shadow: 0px 0px 0px 2px red inset;
    border: unset;
    height: 97%;
    border-right: 1px solid black;
}
:global(.constructor_top .plus:hover)  {
    box-shadow: 0px 0px 0px 2px red inset;
    border: unset;
    height: 97%;
}
.constructor_top {
    display: flex;
    width: 100%;
    height: 33%;
    position: absolute;
    top: 0;
    left: 0;
}
.constructor_middle {
    display: flex;
    left: 14.8%;
    width: 70.4%;
    top: 0;
    height: 100%;
    flex-direction: column;
    position: absolute;
}
.constructor_mid {
    display: flex;
    width: 100%;
    height: 35%;
    position: absolute;
    left: 0;
    top: 32%;
}
.constructor_bot {
    display: flex;
    width: 85.8%;
    height: 32%;
    position: absolute;
    right: -3px;
    bottom: 0px;
}
.constructor_right {
    display: flex;
    right: 0;
    top: 0;
    width: 14.8%;
    height: 100%;
    position: absolute;
}
.constructor {
    display: flex;
    width: 100%;
}
.middle .constructor {
    flex-direction: column;
}
.dragstart_topside .top_side_constructor_top .frost {
    border: 1px solid black;
    height: 72px;
    margin-top: -10px;
    background: white;
}
.middle .dragstart_topside .top_side_constructor_top .frost {
    height: 32px;
    background: white;
    margin-top: -5px;
    border: 1px solid black;
    padding-top: 5px;
}
.dragstart_topside .top_side_constructor_bot .frost {
    border: 1px solid black;
    height: 72px;
    margin-bottom: -10px;
    background: white;
}
.middle .dragstart_topside .top_side_constructor_bot .frost {
    height: 32px;
    padding-top: 5px;
    border: 1px solid black;
}
.top_side_constructor_top .frost, .top_side_constructor_bot .frost{
    border:unset;
    height: 52px;
}
.top_side_constructor_bot .frost {
    margin-top: 10px;
}
.middle .top_side_constructor_top .frost, .middle .top_side_constructor_bot .frost{
    border:unset;
    height: 32px;
    margin-top: 0;
}
.middle .top_side_constructor_bot .frost{
    padding-top: 5px;
}
.top_side_constructor_bot .plus, .top_side_constructor_top .plus{
    background: unset;
}
.top_side_constructor_bot .plus:hover:after, .top_side_constructor_top .plus:hover:after{
    border-color: #ff0000;
    background: url('./images/red-plus.png') no-repeat;
    background-position: center;
}
.top_side_constructor_bot .plus:after, .top_side_constructor_top .plus:after{
    background: unset;
    content: "";
    background: url('./images/plus.png') no-repeat;
    height: 100%;
    background-position: center;
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    border: 1px solid #000;
    left: 50%;
    margin-left: -26px;
    z-index: 100000;
}
.top_side_constructor_bot .plus:after{
    margin-top: 10px;
}
.middle .top_side_constructor_bot .plus:after, .middle .top_side_constructor_top .plus:after{
    width: 15px;
    height: 15px;
    background-size: 11px;
    background-position: center;
}
.middle .top_side_constructor_bot .plus:after{
    margin-top: 5px;
}
.top_side_item:hover {
    border: 1px solid red;
}
.top_side_constructor_bot {
    display: flex;
    width: 85.8%;
    position: absolute;
    right: -3px;
    bottom: -50px;
    height: 70px;
    padding-bottom: 10px;
}
.middle .top_side_constructor_bot {
    bottom: -24px;
    height: 32px;
}
.top_side_item {
    width: 50px;
    max-width: 50px;
    height: 50px;
    max-height: 50px;
    border: 1px solid #000;
    border-radius: 25px;
    background: #fff;
}
.constructor_top .frost{
    height: 97%;
}
.constructor_top .plus{
    height: 97%;
}
.constructor_right {
    display: flex;
    right: 0;
    top: 0;
    width: 14.8%;
    height: 100%;
    position: absolute;
}
.contructor_info_item_one {
    display: flex;
    flex-direction: row;
}
.contructor_info_item_two {
    display: flex;
    flex-direction: row;
}
.contructor_info_title {
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 19px;
    color: #FF0000;
    text-align: center;
    height: 20%;
}
.contructor_info {
    width: 23%;
    min-width: 20px;
    height: auto;
    margin-left: 2%;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    padding: 20px 0;
    overflow: hidden;
}
.middle .contructor_info {
    width: 100%;
    margin-top: 40px;
    border: unset;
}
.contructor_info_item_wrap {
    height: 92%;
    overflow: scroll;
    padding: 0 20px;
    flex: 1;
}

.top_side_item:hover {
    border: 1px solid red;
}
.top_side_constructor_bot {
    display: flex;
    width: 85.8%;
    position: absolute;
    right: -3px;
    bottom: -50px;
    height: 70px;
    padding-bottom: 10px;
}
.middle .top_side_constructor_bot {
    bottom: -24px;
    height: 32px;
}
.top_side_item {
    width: 50px;
    max-width: 50px;
    height: 50px;
    max-height: 50px;
    border: 1px solid #000;
    border-radius: 25px;
    background: #fff;
}
.constructor_top .frost{
    height: 97%;
}
.constructor_top .plus{
    height: 97%;
}

.dragstart_topside .top_side_constructor_top .frost {
    border: 1px solid black;
    height: 72px;
    margin-top: -10px;
    background: white;
}
.middle .dragstart_topside .top_side_constructor_top .frost {
    height: 32px;
    background: white;
    margin-top: -5px;
    border: 1px solid black;
    padding-top: 5px;
}
.dragstart_topside .top_side_constructor_bot .frost {
    border: 1px solid black;
    height: 72px;
    margin-bottom: -10px;
    background: white;
}
.middle .dragstart_topside .top_side_constructor_bot .frost {
    height: 32px;
    padding-top: 5px;
    border: 1px solid black;
}
.frost {
    height: 99%;
    border: 1px solid black;
    background-position: center;
}
.dragstart_topside .frostside{
    border: unset;
    width: 100%;
    height: 100%;
    border-radius: 0;
}
.frostside{
    width: 52px;
    height: 52px;
    border-radius: 100%;
    border: 1px solid #000;
    margin: 0 auto;
    z-index: 100000;
    position: relative;
}
.middle .frostside{
    width: 22px;
    height: 22px;
}
.top_side_constructor_top .frost, .top_side_constructor_bot .frost{
    border:unset;
    height: 52px;
}
.top_side_constructor_bot .frost {
    margin-top: 10px;
}
.middle .top_side_constructor_top .frost, .middle .top_side_constructor_bot .frost{
    border:unset;
    height: 32px;
    margin-top: 0;
}
.middle .top_side_constructor_bot .frost{
    padding-top: 5px;
}
:global(.plus) {

    height: 100%;
    background-position: center;
    /*cursor: pointer;*/
    position: absolute;
    max-width: 100%;

}
.plus:hover:after{
    background: url('./images/red-plus.png') no-repeat;
    background-position: center;
}
.plus:after{
    content: "";
    display: block;
    background: url('./images/plus.png') no-repeat;
    height: 100%;
    background-position: center;
    /*cursor: pointer;*/
    position: absolute;
    max-width: 100%;
    width: 100%;
    z-index: 99999;
}
.middle .plus:after{
    background-size: 11px;
}
.middle .plus:hover:after{
    background-size: 11px;
}
.top_side_constructor_bot .plus, .top_side_constructor_top .plus{
    background: unset;
}
.top_side_constructor_bot .plus:hover:after, .top_side_constructor_top .plus:hover:after{
    border-color: #ff0000;
    background: url('./images/red-plus.png') no-repeat;
    background-position: center;
}

.top_side_constructor_bot .plus:after, .top_side_constructor_top .plus:after{
    background: unset;
    content: "";
    background: url('./images/plus.png') no-repeat;
    height: 100%;
    background-position: center;
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    border: 1px solid #000;
    left: 50%;
    margin-left: -26px;
    z-index: 100000;
}
.top_side_constructor_bot .plus:after{
    margin-top: 10px;
}
.middle .top_side_constructor_bot .plus:after, .middle .top_side_constructor_top .plus:after{
    width: 15px;
    height: 15px;
    background-size: 11px;
    background-position: center;
}
.middle .top_side_constructor_bot .plus:after{
    margin-top: 5px;
}
.constructor_bot div:hover  {
    box-shadow: 0px 0px 0px 2px red inset;
    border: unset;
    height: 99%;
    border-right: 1px solid black;
}
.constructor_bot .plus:hover  {
    box-shadow: 0px 0px 0px 2px red inset;
    border: unset;
    height: 99%;
}
.constructor_top div:hover  {
    box-shadow: 0px 0px 0px 2px red inset;
    border: unset;
    height: 97%;
    border-right: 1px solid black;
}
:global(.constructor_top .plus:hover)  {
    box-shadow: 0px 0px 0px 2px red inset;
    border: unset;
    height: 97%;
}
.constructor_img img{
    width: 100%;
}
.constructor_img {
    width: 75%;
    /* height: 100%; */
    background-size: contain;
    display: flex;
    flex-direction: row;
    position: relative;
    margin: 0 auto;
}
.middle .constructor_img {
    width: 75%;
}
.constructor_left {
    display: flex;
    left: 0;
    top: 0;
    width: 14.8%;
    height: 100%;
    position: absolute;
}
.constructor_middle {
    display: flex;
    left: 14.8%;
    width: 70.4%;
    top: 0;
    height: 100%;
    flex-direction: column;
    position: absolute;
}
.constructor_top {
    display: flex;
    width: 100%;
    height: 33%;
    position: absolute;
    top: 0;
    left: 0;
}
.constructor_mid {
    display: flex;
    width: 100%;
    height: 35%;
    position: absolute;
    left: 0;
    top: 32%;
}
.constructor_bot {
    display: flex;
    width: 85.8%;
    height: 32%;
    position: absolute;
    right: -3px;
    bottom: 0px;
}
.constructor_right {
    display: flex;
    right: 0;
    top: 0;
    width: 14.8%;
    height: 100%;
    position: absolute;
}
.constructor {
    display: flex;
    width: 100%;
}
.middle .constructor {
    flex-direction: column;
}
.disabled_checkbox {
    opacity: .6;
}
.exceptionElement {
    position: absolute;
    height: 100%;
    background-color: red;
    opacity: 0.6;
    display:none;
}
.exceptionElementTopSide {
    position: absolute;
    height: 100%;
    background-color: red;
    opacity: 0.6;
    display:none;
}
.dragstart .exceptionElement {
    display:block;
}
.dragstart_topside .exceptionElementTopSide {
    display:block;
}
.dragover {
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:2;
    background-color:green;
    opacity:0.3;
    display:none;
    z-index: 9999999;
}
.dragstart .dragover {
    display:block;
}
.dragover_topside {
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:2;
    background-color:green;
    opacity:0.3;
    display:none;
    z-index: 9999999;
}
.dragstart_topside .dragover_topside {
    display:block;
}
.middle .submit_info{
    width: 300px;
}
.info_item_one_text {
    /*height: 40px;*/
    width: 70%;
    display: flex;
}
.info_item_two_text {
    height: 80px;
    width: 100%;
}
.info_item_one_text_p{
    font-size: 14px;
    line-height: 15px;
    text-align: center;
    color: #404455;
    margin: auto;
}
.middle .info_item_one_text_p {
    margin: auto auto auto 15px;
}
.info_item_two_text_p{
    font-size: 14px;
    line-height: 15px;
    text-align: left;
    color: #404455;
}
.contructor_info_item_one {
    display: flex;
    flex-direction: row;
}
.contructor_info_item_two {
    display: flex;
    flex-direction: row;
}
.contructor_info_title {
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 19px;
    color: #FF0000;
    text-align: center;
    height: 20%;
}
.contructor_info {
    width: 23%;
    min-width: 20px;
    height: auto;
    margin-left: 2%;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    padding: 20px 0;
    overflow: hidden;
}
.middle .contructor_info {
    width: 100%;
    margin-top: 40px;
    border: unset;
}
.contructor_info_item_wrap {
    height: 92%;
    overflow: scroll;
    padding: 0 20px;
}
.constructor .constructor_img .track_layer {
    width: 100%;
    height: 100%;
    position: absolute;
    display: block;
    z-index: -1;
    top: 0;
}
</style>
<script>
    import ConstructorPosition from './ConstructorPosition.svelte';
    import { mutations, track, goodsList, responsiveClass } from '../../mainStore.js';
    import helper from '../../helper.js';
    export let readOnly = false;

    let constructor_class = 'constructor_class';
    let itemsArray = [];
    let plusList = [];
    let touchX = 0;
    let touchY = 0;
    function clearPlusList(){
        plusList = []
    }
    function itemMove(event) {
        let eventItem = event.detail.eventItem;
        let x;
        let bort_width_px;
        x = eventItem.x;
        bort_width_px = eventItem.width;

        let x_percent = x/bort_width_px*100;
        let x_mm = (eventItem.widthInMm/100)*x_percent - offset;

        if (eventItem.draggedItem) {
            let oldPosition = eventItem.draggedItem.position
            eventItem.draggedItem.position = eventItem.positionName
            let tryX = x_mm;
            if (tryX + eventItem.draggedItem.width > eventItem.widthInMm) {
                tryX = eventItem.widthInMm - eventItem.draggedItem.width
            } else if (tryX < 0) {
                tryX = 0
            }
            let exception = helper.getException({x1: tryX, x2: (tryX + eventItem.draggedItem.width)}, eventItem.exceptionPlaceList);
            if (!exception) {
                mutations.setItemPosition(eventItem.draggedItem, eventItem.positionName, tryX);
                return
            }

            if (Math.abs(exception.x1 - (x_mm + eventItem.draggedItem.width)) < Math.abs(exception.x2 - (x_mm))) {
                tryX = exception.x1 - eventItem.draggedItem.width - 1;
            } else {
                tryX = exception.x2 + 1;
            }
            if (tryX + eventItem.draggedItem.width > eventItem.widthInMm) {
                tryX = eventItem.widthInMm - eventItem.draggedItem.width
            } else if (tryX < 0) {
                tryX = 0
            }
            exception = helper.getException({x1: tryX, x2: (tryX + eventItem.draggedItem.width)}, eventItem.exceptionPlaceList);
            if (!exception) {
                mutations.setItemPosition(eventItem.draggedItem, eventItem.positionName, tryX);
                return
            }
            eventItem.draggedItem.position = oldPosition
        }
    }
    function touchMove(event) {
        touchX = event.touches[0].clientX;
        touchY = event.touches[0].clientY
    }
    function getWidth(track) {
        if (track.type == 1) {
            return 84
        }
        if (track.type == 2) {
            return 75
        }
        if (track.type == 3) {
            return 86
        }
        if (track.type == 4) {
            return 81
        }
    }
    let load = false;
    let offset = 0;
</script>
<div class="constructor {constructor_class} {$responsiveClass}" on:touchmove={touchMove}>
    <div class="constructor_img" style="width:{getWidth($track)}%;">
        <img on:load={() => {load = true}} src="{$track.schema_image}" alt="" >
        {#each $goodsList as item}
            {#if (item.layer_image)}
                <img src="{item.layer_image}" class="track_layer" alt="">
            {/if}
        {/each}
        {#if (load)}
            {#if ($track.type == 2)}
                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="1.7" top="11.3" width="24.1" height="77.4" haveTopSide={true} radiusTopLeft="999" radiusBottomLeft="999"
                    widthInMm={$track.width_right} positionName="left" horizontal={false} orientation="left" on:itemMove={itemMove} touchX={touchX} touchY={touchY} />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} right="1.7" top="11.3" width="22.5" height="77.4" haveTopSide={true} radiusTopRight="999" radiusBottomRight="999"
                    widthInMm={$track.width_left} positionName="right" horizontal={false} orientation="right" on:itemMove={itemMove} touchX={touchX} touchY={touchY} />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="25.2" top="11.3" width="51" height="23" widthInMm={$track.width_top}
                    positionName="top" on:itemMove={itemMove} touchX={touchX} touchY={touchY} orientation="top" />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="25.2" bottom="11" width="30.9" height="24.8" radiusTopRight="5" widthInMm={$track.width_bottom}
                    positionName="bottom" on:itemMove={itemMove} touchX={touchX} touchY={touchY} orientation="bottom" />
            {/if}

            {#if ($track.type == 1)}
                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="1" top="12" width="14.8" height="77" haveTopSide={true} radiusTopLeft="999" radiusBottomLeft="999"
                    widthInMm={$track.width_right} positionName="left" horizontal={false} orientation="left" on:itemMove={itemMove} touchX={touchX} touchY={touchY} />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} right="1" top="12" width="14.8" height="77" haveTopSide={true} radiusTopRight="999" radiusBottomRight="999"
                    widthInMm={$track.width_left} positionName="right" horizontal={false} orientation="right" on:itemMove={itemMove} touchX={touchX} touchY={touchY} />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="15.47" top="12" width="69.1" height="24.9" widthInMm={$track.width_top}
                    positionName="top" on:itemMove={itemMove} touchX={touchX} touchY={touchY} orientation="top" />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="25.6" bottom="11.6" width="58.9" height="24.7" radiusTopLeft="5" widthInMm={$track.width_bottom}
                    positionName="bottom" on:itemMove={itemMove} touchX={touchX} touchY={touchY} orientation="bottom" />
            {/if}

            {#if ($track.type == 3)}
                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="1" top="11.3" width="11.4" height="77.8"
                    widthInMm={$track.width_right} positionName="left" horizontal={false} tri={true} haveTopSide={true} orientation="left" on:itemMove={itemMove} touchX={touchX} touchY={touchY} />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} right="1" top="11.3" width="11.4" height="77.8"
                    widthInMm={$track.width_left} positionName="right" horizontal={false} tri={true} haveTopSide={true} orientation="right" on:itemMove={itemMove} touchX={touchX} touchY={touchY} />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="12.1" top="11.5" width="75.9" height="24.4" widthInMm={$track.width_top}
                    positionName="top" on:itemMove={itemMove} touchX={touchX} touchY={touchY} orientation="top" />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="12.1" bottom="11" width="64" height="24.9" radiusTopRight="5" widthInMm={$track.width_bottom}
                    positionName="bottom" on:itemMove={itemMove} touchX={touchX} touchY={touchY} orientation="bottom" />
            {/if}

            {#if ($track.type == 4)}
                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="1" top="11.5" width="15.3" height="77.5"
                    widthInMm={$track.width_right} positionName="left" horizontal={false} tri={true} haveTopSide={true} orientation="left" on:itemMove={itemMove} touchX={touchX} touchY={touchY} />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} right="1" top="11.5" width="15.3" height="77.5"
                    widthInMm={$track.width_left} positionName="right" horizontal={false} tri={true} haveTopSide={true} orientation="right" on:itemMove={itemMove} touchX={touchX} touchY={touchY} />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="16.2" top="11.5" width="67.6" height="24.4" widthInMm={$track.width_top}
                    positionName="top" on:itemMove={itemMove} touchX={touchX} touchY={touchY} orientation="top" />

                <ConstructorPosition readOnly={readOnly} bind:offset={offset} left="32.9" bottom="11.3" width="51.1" height="24.8" radiusTopLeft="5" widthInMm={$track.width_bottom}
                    positionName="bottom" on:itemMove={itemMove} touchX={touchX} touchY={touchY} orientation="bottom" />
            {/if}
        {/if}
    </div>
</div>
